import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { Typography, Button } from "@mui/material";
import { Request_Get_Registers_Fuzzy_Search } from "../../pages/Registers/api/Request_Get_Registers_Fuzzy_Search";
import { Get_limited_Choose_Fields_From_MongoDB } from "../../api/Get_limited_Choose_Fields_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { StaffuseAuth } from "../../security/StaffuseAuth";
import getNestedPropBySearchProp from "../../../functions/getNestedPropBySearchProp";
import { Get_Registers_With_Options } from "../../api/Get_Registers_With_Options";

function SearchSetRegisters({ setRegisters, initialSearch }) {
  const { logout } = StaffuseAuth();

  const [selectedField, setSelectedField] = useState("");
  const handleFieldChange = (event) => {
    setSelectedField(event.target.value);
  };

  const [inputValues, setInputValues] = useState(
    initialSearch ? initialSearch : {}
  );

  const handleInputChange = (event) => {
    if (selectedField === "IP") {
      setInputValues({
        ...inputValues,
        [selectedField]: event.target.value,
        Agencies: "",
        EC: "",
      });
    } else if (selectedField === "Agencies") {
      setInputValues({
        ...inputValues,
        [selectedField]: event.target.value,
        IP: "",
        EC: "",
      });
    } else if (selectedField === "EC") {
      setInputValues({
        ...inputValues,
        [selectedField]: event.target.value,
        IP: "",
        Agencies: "",
      });
    } else {
      setInputValues({
        ...inputValues,
        [selectedField]: event.target.value,
      });
    }
  };

  const [limit, setlimit] = useState(20);
  const handleLimitChange = (event) => {
    setlimit(event.target.value);
  };
  function handleSubmit(e) {
    e.preventDefault();
    Request_Get_Registers_Fuzzy_Search(
      "Registers_2025",
      "All",
      inputValues,
      Number(limit),
      setRegisters,
      logout
    );
  }

  // function handleSimpleSubmit(e) {
  //   e.preventDefault();
  //   Get_Registers_With_Options(
  //     "Registers_2025",
  //     "All",
  //     inputValues,
  //     Number(limit),
  //     {
  //       customProject: {
  //         BasicInfo: 1,
  //         MetaData: 1,
  //         OrderInfo: 1,
  //         Contacts: 1,
  //         _id: 1,
  //       },
  //     },
  //     setRegisters,
  //     logout
  //   );
  // }

  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
      "Staff",
      "Users",
      {},
      1000,
      setStaff,
      "Username",
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);
  //Filter the staff for IP's
  let IPStaff = Staff.filter((prop) =>
    prop.Team.toLowerCase().includes("ip".toLowerCase())
  );

  //Get EC's
  const [ECs, setECs] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
      "IP",
      "EC",
      {},
      10000,
      setECs,
      "BasicInfo.First_Name",
      {
        BasicInfo: 1,
        MetaData: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  const [searchEC, setSearchEC] = useState("");
  const handleInputChangesearchEC = (event) => {
    setSearchEC(event.target.value);
  };

  const ECsFiltered = ECs.filter((EC) => {
    return searchEC.split(" ").every((word) => {
      return Object.values(EC).some((value) => {
        if (typeof value === "object") {
          return Object.values(value).some((value2) => {
            return value2.toString().toLowerCase().includes(word.toLowerCase());
          });
        }
        return value.toString().toLowerCase().includes(word.toLowerCase());
      });
    });
  });

  //Get Agencies
  const [Agencies, setAgencies] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
      "IP",
      "Agencies",
      {},
      10000,
      setAgencies,
      "BasicInfo.Name",
      {
        BasicInfo: 1,
        MetaData: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  const [searchAgencies, setSearchAgencies] = useState("");
  const handleInputChangesearchAgencies = (event) => {
    setSearchAgencies(event.target.value);
  };

  const AgenciesFiltered = Agencies.filter((Agency) => {
    return searchAgencies.split(" ").every((word) => {
      return Object.values(Agency).some((value) => {
        if (typeof value === "object") {
          return Object.values(value).some((value2) => {
            return value2.toString().toLowerCase().includes(word.toLowerCase());
          });
        }
        return value.toString().toLowerCase().includes(word.toLowerCase());
      });
    });
  });

  //Get all the EC's _id from the state EC where their Agency_id is the same as the inputValues.Agencies value, and then return an array of only their _id values
  const Arr_SearchAgencyECs = ECs.filter(
    (prop) =>
      prop.MetaData.Agency_id === inputValues.Agencies && inputValues.Agencies
  ).map((prop) => prop._id);
  inputValues.Arr_SearchAgencyECs = Arr_SearchAgencyECs;

  //Get all the Agencies's _id's where their IP_id matches the value of the State IP and call this Arr_SearchIPAgencies, then get all the EC's _id from the state EC where their Agency_id is the same as any of the _id's in Arr_SearchIPAgencies, and then return an array of only their _id values
  const Arr_SearchIPAgencies = Agencies.filter(
    (prop) => prop.MetaData.IP_id === inputValues.IP
  ).map((prop) => prop._id);
  const Arr_SearchIPAgenciesECs = ECs.filter((prop) =>
    Arr_SearchIPAgencies.includes(prop.MetaData.Agency_id)
  ).map((prop) => prop._id);
  inputValues.Arr_SearchIPAgenciesECs = Arr_SearchIPAgenciesECs;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center", // This ensures vertical center alignment
        gap: 2, // Adjusts spacing between items
        marginRight: "150px",
      }}
    >
      <FormControl sx={{ flexGrow: 1, minWidth: "150px" }}>
        <InputLabel id="search-field-label">Search Field</InputLabel>
        <Select
          labelId="search-field-label"
          id="search-field"
          value={selectedField}
          label="Search Field"
          onChange={handleFieldChange}
        >
          <MenuItem value="First_Name">First Name</MenuItem>
          <MenuItem value="Last_Name">Last Name</MenuItem>
          <MenuItem value="Email">Email</MenuItem>
          <MenuItem value="ProgrammeTitle">ProgrammeTitle</MenuItem>
          <MenuItem value="ProgrammeDate">ProgrammeDate</MenuItem>
          <MenuItem value="ProgrammeVarient">ProgrammeVarient</MenuItem>
          <MenuItem value="Nationality">Nationality</MenuItem>
          <MenuItem value="uncleanSchool">uncleanSchool</MenuItem>
          <MenuItem value="EC">EC</MenuItem>
          <MenuItem value="Agencies">Agencies</MenuItem>
          <MenuItem value="IP">IP</MenuItem>
          <MenuItem value="TCS">TCS</MenuItem>
          <MenuItem value="Reserved">Reserved</MenuItem>
          <MenuItem value="Archived">Archived</MenuItem>
          <MenuItem value="Bursary">Bursary</MenuItem>
          <MenuItem value="Scholarship">Scholarship</MenuItem>
          <MenuItem value="SEF">SEF</MenuItem>
          <MenuItem value="SummerArrivalDepartureProgress">
            Arrival Departure
          </MenuItem>
          <MenuItem value="ID">ID Exact</MenuItem>

          {/* Add more fields as needed */}
        </Select>
      </FormControl>
      {selectedField &&
        selectedField !== "Reserved" &&
        selectedField !== "Archived" &&
        selectedField !== "Bursary" &&
        selectedField !== "Scholarship" &&
        selectedField !== "EC" &&
        selectedField !== "TCS" &&
        selectedField !== "IP" &&
        selectedField !== "Agencies" &&
        selectedField !== "SummerArrivalDepartureProgress" &&
        selectedField !== "SEF" && (
          <TextField
            id="search-input"
            label={`Enter ${selectedField.replace(/^\w/, (c) =>
              c.toUpperCase()
            )}`}
            variant="outlined"
            value={inputValues[selectedField] || ""}
            onChange={handleInputChange}
            fullWidth
            sx={{ mt: 2, my: "auto", maxWidth: "200px" }}
          />
        )}
      {selectedField &&
        (selectedField === "Reserved" ||
          selectedField === "Archived" ||
          selectedField === "TCS" ||
          selectedField === "Scholarship" ||
          selectedField === "Bursary") && (
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel id="yes-no-label">{`${selectedField.replace(
              /^\w/,
              (c) => c.toUpperCase()
            )}`}</InputLabel>
            <Select
              labelId="yes-no-label"
              id="yes-no-select"
              value={inputValues[selectedField] || ""}
              label={`${selectedField.replace(/^\w/, (c) => c.toUpperCase())}`}
              onChange={handleInputChange}
            >
              <MenuItem value="Yes">Yes</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
          </FormControl>
        )}
      {selectedField && selectedField === "SEF" && (
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel id="SEF-label">{`${selectedField.replace(/^\w/, (c) =>
            c.toUpperCase()
          )}`}</InputLabel>
          <Select
            labelId="SEF-label"
            id="SEF-label"
            value={inputValues[selectedField] || ""}
            label={`${selectedField.replace(/^\w/, (c) => c.toUpperCase())}`}
            onChange={handleInputChange}
          >
            <MenuItem value="">---</MenuItem>
            <MenuItem value="Incomplete">Incomplete</MenuItem>
            <MenuItem value="In_Progress">In Progress</MenuItem>
            <MenuItem value="Incomplete or In_Progress">
              Incomplete or In Progress
            </MenuItem>
            <MenuItem value="Awaiting_Review">Awaiting Review</MenuItem>
            <MenuItem value="Complete">Complete</MenuItem>
          </Select>
        </FormControl>
      )}
      {selectedField && selectedField === "SummerArrivalDepartureProgress" && (
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel id="SummerArrivalDepartureProgress-label">{`${selectedField.replace(
            /^\w/,
            (c) => c.toUpperCase()
          )}`}</InputLabel>
          <Select
            labelId="SummerArrivalDepartureProgress-label"
            id="SummerArrivalDepartureProgress-label"
            value={inputValues[selectedField] || ""}
            label={`${selectedField.replace(/^\w/, (c) => c.toUpperCase())}`}
            onChange={handleInputChange}
          >
            <MenuItem value="">---</MenuItem>
            <MenuItem value="Incomplete">Incomplete</MenuItem>
            <MenuItem value="In_Progress">In Progress</MenuItem>
            <MenuItem value="Incomplete or In_Progress">
              Incomplete or In Progress
            </MenuItem>
            <MenuItem value="Awaiting_Review">Awaiting Review</MenuItem>
            <MenuItem value="Complete">Complete</MenuItem>
          </Select>
        </FormControl>
      )}
      {selectedField && selectedField === "IP" && (
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel id="yes-no-label">{`${selectedField.replace(/^\w/, (c) =>
            c.toUpperCase()
          )}`}</InputLabel>
          <Select
            labelId="yes-no-label"
            id="yes-no-select"
            value={inputValues[selectedField] || ""}
            label={`${selectedField.replace(/^\w/, (c) => c.toUpperCase())}`}
            onChange={handleInputChange}
          >
            <MenuItem value={""}>Null</MenuItem>
            {IPStaff.map((IP) => (
              <MenuItem value={IP._id}>{IP.Username}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {selectedField && selectedField === "EC" && (
        <>
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel id="yes-no-label">{`${selectedField.replace(
              /^\w/,
              (c) => c.toUpperCase()
            )}`}</InputLabel>
            <Select
              labelId="yes-no-label"
              id="yes-no-select"
              value={inputValues[selectedField] || ""}
              label={`${selectedField.replace(/^\w/, (c) => c.toUpperCase())}`}
              onChange={handleInputChange}
            >
              <MenuItem value={""}>Null</MenuItem>
              {ECsFiltered.map((EC) => (
                <MenuItem value={EC._id}>
                  {EC.BasicInfo
                    ? EC.BasicInfo.First_Name +
                      " " +
                      EC.BasicInfo.Last_Name +
                      ", " +
                      EC.BasicInfo.Email
                    : "---"}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            id="search-input"
            label={`Enter Text...`}
            variant="outlined"
            value={searchEC}
            onChange={handleInputChangesearchEC}
            fullWidth
            sx={{ mt: 2, my: "auto", maxWidth: "200px" }}
          />
        </>
      )}
      {selectedField && selectedField === "Agencies" && (
        <>
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel id="yes-no-label">{`${selectedField.replace(
              /^\w/,
              (c) => c.toUpperCase()
            )}`}</InputLabel>
            <Select
              labelId="yes-no-label"
              id="yes-no-select"
              value={inputValues[selectedField] || ""}
              label={`${selectedField.replace(/^\w/, (c) => c.toUpperCase())}`}
              onChange={handleInputChange}
            >
              <MenuItem value={""}>Null</MenuItem>
              {AgenciesFiltered.map((Agency) => (
                <MenuItem value={Agency._id}>
                  {Agency.BasicInfo
                    ? Agency.BasicInfo.Name +
                      ", " +
                      Agency.BasicInfo.Email +
                      ", " +
                      Agency.BasicInfo.Country
                    : "---"}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            id="search-input"
            label={`Enter Text...`}
            variant="outlined"
            value={searchAgencies}
            onChange={handleInputChangesearchAgencies}
            fullWidth
            sx={{ mt: 2, my: "auto", maxWidth: "200px" }}
          />
        </>
      )}
      {/* New Component for displaying filters in use */}
      {Object.keys(inputValues).length > 0 && (
        <Box sx={{ mt: 2, maxWidth: "900px" }}>
          <Typography variant="subtitle1">Search Details:</Typography>
          {Object.entries(inputValues).map(([key, value]) => (
            <>
              {value.length > 0 &&
              key !== "Arr_SearchIPAgenciesECs" &&
              key !== "Arr_SearchAgencyECs" ? (
                <Typography key={key}>{`${key.replace(/^\w/, (c) =>
                  c.toUpperCase()
                )}: ${value}`}</Typography>
              ) : (
                ""
              )}
            </>
          ))}
        </Box>
      )}
      <FormControl sx={{ minWidth: 120 }}>
        <TextField
          id="limit-input"
          label="Limit"
          type="number"
          value={limit}
          onChange={handleLimitChange}
          InputProps={{ inputProps: { min: 1 } }}
          variant="outlined"
          fullWidth
          sx={{ mt: 2, my: "auto", maxWidth: "100px" }}
        />
      </FormControl>{" "}
      {/* <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ flex: "none", maxWidth: "200px" }}
        onClick={(e) => {
          handleSimpleSubmit(e);
        }}
      >
        Quick Search (Pulls limited Data, but quick load time)
      </Button> */}
      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ flex: "none", maxWidth: "200px" }}
        onClick={(e) => {
          handleSubmit(e);
        }}
      >
        Load
      </Button>
    </Box>
  );
}

export default SearchSetRegisters;
